<div class="cont-blog mt-4 py-5">
  <div class="container">
    <div class="row align-items-center py-5">

      <!-- Columna izquierda: Texto -->
      <div class="col-12 col-xl-3 text-start d-flex flex-column justify-content-center mb-4 mb-xl-0">
        <h2 class="title-dark font-size-36 mb-4">
          <b>Consejos y guías para tu próximo viaje</b>
        </h2>
        <p class="description-blog mb-5">
          Descubre recomendaciones, requisitos de destino y tips para viajar con tranquilidad.
        </p>
        <div>
          <button class="btn btn-dark-custom">
            <a href="/blog" target="_blank" class="text-decoration-none text-white">Leer más &rarr;</a>
          </button>
        </div>
      </div>

      <!-- DESKTOP: 3 cards visibles en fila -->
      <div class="col-xl-9 d-none d-xl-block">
        <div class="blog-grid-desktop">
          <div class="blog-card-item" *ngFor="let post of posts">
            <div class="card blog-card border-0 shadow-sm d-flex flex-column">
              <img [src]="post.img" class="card-img-top blog-img" alt="Blog post image">
              <div class="card-body d-flex flex-column p-4 text-start">
                <h5 class="card-title blog-title">{{post.title}}</h5>
                <p class="card-text blog-text flex-grow-1">{{post.content}}</p>
                <div class="view-more-container mt-3">
                  <a href="{{post.url}}" target="_blank" class="view-more-link text-decoration-none">
                    Ver más <span style="font-size: 16px; margin-left: 2px;">&#x2197;</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MOBILE: Carousel horizontal (sale del flujo del container para ir edge-to-edge) -->
      <div class="col-12 d-xl-none px-2">
        <div class="blog-cards-scroll" #mobileScrollContainer>
          <div class="blog-card-item-mobile" *ngFor="let post of posts">
            <div class="card blog-card border-0 shadow-sm d-flex flex-column">
              <img [src]="post.img" class="card-img-top blog-img" alt="Blog post image">
              <div class="card-body d-flex flex-column p-4 text-start">
                <h5 class="card-title blog-title">{{post.title}}</h5>
                <p class="card-text blog-text flex-grow-1">{{post.content}}</p>
                <div class="view-more-container mt-3">
                  <a href="{{post.url}}" target="_blank" class="view-more-link text-decoration-none">
                    Ver más <span style="font-size: 16px; margin-left: 2px;">&#x2197;</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
